import { createContext, useContext } from "react";
import type { ShareVoiceSidebarCategory } from "@/data-access/share-of-voice/queries/shareOfVoice-sidebar-filter-queries";

/**
 * Context value for discovery data.
 * Provides feedId, dates, and filters to nested components (e.g. FeedArticlesTable, cell renderers).
 */
export interface DiscoveryContextValue {
  feedId: string;
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  selectedFilters: Partial<Record<ShareVoiceSidebarCategory, string[]>>;
}

const DiscoveryContext = createContext<DiscoveryContextValue | null>(null);

export const DiscoveryProvider = DiscoveryContext.Provider;

/**
 * Hook to access discovery context.
 * Throws if used outside of a DiscoveryProvider.
 */
export const useDiscoveryContext = (): DiscoveryContextValue => {
  const context = useContext(DiscoveryContext);
  if (!context) {
    throw new Error(
      "useDiscoveryContext must be used within a DiscoveryProvider",
    );
  }
  return context;
};
